import {Role} from '../../constantes/role.constantes';
import {MenuItemsAggregate} from './menu-items.aggregate';

export class MenuLeftByRoleAggregate {
  constructor(readonly role: Role, readonly menuItems: MenuItemsAggregate) {}
}
